import RestAPI from '../../Common/restApi';

export default class AppDetailsApi {
  static disconnectGoogleCalendar() {
    return RestAPI.delete('/pro/google/calendar');
  }

  static createWebhookConfiguration(params) {
    return RestAPI.postWithFormData('/alpha/webhook/configuration', params);
  }

  static updateWebhookConfiguration(params) {
    return RestAPI.updateWithFormData('/alpha/webhook/configuration', params);
  }

  static getWebhookConfiguration() {
    return RestAPI.get('/alpha/webhook/configuration');
  }

  static createZapierConfiguration(params) {
    return RestAPI.postWithFormData('/alpha/zapier/configuration', params);
  }

  static updateZapierConfiguration(params) {
    return RestAPI.updateWithFormData('/alpha/zapier/configuration', params);
  }

  static getZapierConfiguration() {
    return RestAPI.get('/alpha/zapier/configuration');
  }

  static getAllEvents() {
    return RestAPI.get('/alpha/webhook/event_types');
  }

  static deleteWebhookConfiguration() {
    return RestAPI.updateWithFormData('/alpha/webhook/configuration', null);
  }
}
